{
  "common": {
    "continue": "CONTINUAR",
    "back": "Voltar",
    "ok": "OK",

    "skip_step": "PULAR ETAPA",
    "confirm": "CONFIRMAR",
    "your_answer": "SUA RESPOSTA",
    "required_answer": "VOCÊ PRECISA ESCREVER UMA RESPOSTA",
    "insert_keyword": "Insira a palavra-chave corretamente para desativar o sistema"
  },

  "intro": {
    "point_phone_totem":"Aponte o celular para esta imagem",
    "target_title": "Para começar, o sistema precisa detectar você.",
    "target_text": "Encontre a imagem inicial no Ponto Epix, na Rua B entre as ruas 5 e 6, próximo à área B2B.",

    "story_1_title": "Um colapso dimensional está acontecendo na <span class=\"highlight-white\">gamescom latam.</span>",
    "story_1_text": "Os portais dos quatro mundos — <span class=\"highlight-white\">Hero, Shadow, Neo e Open</span> — estão se desestabilizando. Fragmentos de realidade se espalham pelo evento.",

    "story_2_title": "Você foi escolhido como o Guardião dos Portais.",
    "story_2_text": "Sua missão: percorrer os mundos, decifrar enigmas e provar que entende a essência de cada um.",

    "story_3_title": "A cada acerto, um fragmento é coletado.",
    "story_3_text": "No final, a chave para o Grande Prêmio será revelada.",
    "story_3_call": "Você aceita o chamado?",

    "prizes_intro": "Estas são as possíveis recompensas por restaurar o equilíbrio dos nossos mundos. Siga em frente, Guardião.",
    "prize_exclusive_items": "ITENS EXCLUSIVOS",
    "prize_list_item_1": "CAMISETA EXCLUSIVA DOS MUNDOS DA GAMESCOM LATAM",
    "prize_list_item_2": "CANECA EXCLUSIVA DOS MUNDOS DA GAMESCOM LATAM",
    "prize_list_item_4": "GARRAFA EXCLUSIVA GAMESCOM LATAM",
    "prize_list_item_5": "PINS EXCLUSIVOS GAMESCOM LATAM",
    "prizes_warning": "E mais! Verifique a lista completa na área de retirada dos brindes no Ponto Epix, na Rua B entre as ruas 5 e 6, próximo à área B2B. Lembrando, os brindes estarão sujeitos à disponibilidade de estoque.",

    "form_title": "O sistema dimensional detectou você.",
    "form_text_1": "Antes de atravessar os portais, precisamos saber quem é o Guardião.",
    "form_text_2": "Registre-se. Sua jornada começa agora.",
    "guardian_data": "Dados do Guardião",

    "name_label": "NOME",
    "name_placeholder": "Nome",
    "gender_label": "GÊNERO",
    "gender_placeholder": "Selecione",
    "gender_male": "Masculino",
    "gender_female": "Feminino",
    "gender_other": "Outro",
    "birthdate_label": "DATA DE NASCIMENTO",
    "birthdate_placeholder": "00/00/0000",
    "document_label": "CPF | PASSAPORTE",
    "email_label": "E-MAIL",
    "email_placeholder": "E-MAIL",
    "accept_terms": "Aceitar os termos de uso",

    "tutorial_text_1": "Você enfrentará enigmas de cada mundo. Alguns exigirão palavras-chave escondidas na <span class=\"highlight-white\">gamescom latam.</span>",
    "tutorial_text_2": "Outros testarão seu conhecimento sobre os universos que tanto ama. <span class=\"highlight-white\">Esteja atento!</span>",

    "zone_intro_title": "O primeiro portal se abre. Uma névoa densa esconde criaturas ancestrais.",
    "zone_intro_text": "Para atravessar, você precisa encontrar a palavra que ecoa como um grito silencioso. Você sente o ar mais frio vindo da <span style=\"color:#AD4CFF\">Shadow Zone.</span>"
  },

  "shadowzone": {
    "point_phone_totem":"Aponte o celular para esta imagem",
    "target_title": "Você precisa encontrar a palavra secreta para seguir.",
    "target_text": "Use a realidade aumentada para identificar a imagem escondida na Shadow Zone.",

    "success_title": "Você ouve sua voz ecoando distorcida",
    "success_text": "A névoa se dissipa, o caminho até um fragmento se torna claro e você o recupera.",

    "failure_title": "A palavra não surte efeito algum e a névoa parece ainda mais densa.",
    "failure_text": "Tente novamente, Guardião.",

    "option_a_title": "Experimente de forma inédita este jogo na gamescom latam agora mesmo!",
    "synopsis_placeholder": "Explore de forma inédita uma Gotham reimaginada, onde o humor clássico da franquia LEGO se une à atmosfera épica do Cavaleiro das Trevas em uma jornada inesquecível por gerações de heroísmo.",
    "visit_text": "<span class=\"highlight-hero bold\">Visite o estande da Warner Games!</span>",
    "address": "Rua E, esquina com a Rua 3. Para mais informações, consulte o mapa oficial.",

    "zone_intro_title": "O segundo portal se abre. O clima distópico com tecnologias inimagináveis e cidades tingidas de neon parece estranhamente familiar.",
    "zone_intro_text": "O sistema à sua frente está corrompido. Para burlar os protocolos de defesa e encontrar um dos fragmentos, você precisa da palavra de acesso que só os verdadeiros rebeldes conhecem. Por meio dos rastros de dados você segue rumo à <span class=\"highlight-neo\">Neo Zone</span>."
  },

  "neozone": {
    "point_phone_totem":"Aponte o celular para esta imagem",
    "target_title": "A palavra deve estar escondida na Neo Zone.",
    "target_text": "Use seu smartphone para rastreá-la. Ligue a câmera e procure ao seu redor.",

    "success_title": "O glitch foi resolvido",
    "success_text": "Com o sistema estabilizado o fragmento se manifesta ao alcance de suas mãos",

    "failure_title": "Código incorreto. O alarme dispara.",
    "failure_text": "Tente novamente, Guardião.",

    "question_title": "Guardião, sua jornada pelos mundos exige uma percepção que desafia os limites do comum.",
    "question_prompt": " Para restaurar o equilíbrio e dissipar a névoa do caos, você deve acessar a força que sustenta este multiverso: <span class=\"highlight-neo-regular\"> as tecnologias GeForce RTX, </span>que estão revolucionando os jogos.",
    
    "question_title_2": "Esqueça as amarras da latência.",
    "question_prompt_2": "Aqui, o fluxo dos mundos é constante, permitindo uma imersão completa onde o lag inexiste e a fluidez é absoluta. Desde a ascensão do DLSS 4 com seus modelos Transformers, redefinimos a realidade. <span class=\"highlight-neo-regular\"> Agora, com o novo DLSS 4.5 Super Resolution, a nitidez alcança um patamar divino através de modelos de IA de segunda geração,</span> disponíveis para todos os portadores de GPUs GeForce RTX.",
    "question_prompt_3": "GeForce RTX Série 50, o tempo se curva à sua vontade: <span class=\"highlight-neo-regular\">o Dynamic Multi Frame Generation expande a realidade em até 6 vezes mais quadros,</span> garantindo que seus sentidos nunca percam um detalhe.",

    "question_option_a": "<span class=\"highlight-white\">A)</span> SIM (Ir conhecer <span class=\"highlight-neo\">ESTANDE DA NVIDIA</span>)",
    "question_option_b": "<span class=\"highlight-white\">B)</span> NÃO (Continuar aventura)",

    "option_a_title": "O próximo fragmento da sua evolução o aguarda.",
    "synopsis": "Atravesse as fronteiras digitais e<span class=\"highlight-neo\"> visite o estande da NVIDIA na gamescom latam </span>para testemunhar a forja da perfeição visual e a fluidez que guia o futuro.",
    "address": "Rua E, esquina com a Rua 2. Para mais informações, consulte o mapa oficial",
    "option_a_button": "AVALIE A EXPERIÊNCIA DA NVIDIA",

    "review_intro": "Depois de conhecer este universo tecnológico",
    "review_title": "Conte suas impressões sobre o Estande da NVIDIA",
    "rating": {
      "gamesSelection": "SELEÇÃO DE JOGOS",
      "lines": "FILAS",
      "gift": "BRINDES",
      "service": "ATENDIMENTOS"
    },
    "review_optional": "SENTIU FALTA DE ALGO? <span class=\"highlight-white\">CONTA PRA GENTE</span>",
    "review_confirm": "CONFIRMAR",

    "zone_intro_title": "O portal te mostra um lugar onde as possibilidades são infinitas",
    "zone_intro_text": "você vê o fragmento, em um lugar fora do alcance. Já conhecendo o poder inato das palavras, você segue para a <span class=\"highlight-open\">Open Zone</span>."
  },

  "openzone": {
    "point_phone_totem":"Aponte o celular para esta imagem",
    "target_title": "A realidade é sua para moldar.",
    "target_text": "Encontre a palavra na Open Zone.",

    "success_title": "Obedecendo seu comando",
    "success_text": "Blocos se encaixam em uma escada rumo ao fragmento. O mundo reconhece seu criador.",

    "failure_title": "Ao lançar a palavra, a construção desaba",
    "failure_text": "Comece de novo",

    "option_a_title": "Sinta o peso do legado de um verdadeiro herói no multiverso de<span class=\"highlight-hero-bigger\"> Invincible</span>",
    "synopsis_placeholder": "Enfrente ameaças de escala global e prove que sua força é necessária para proteger a realidade. Uma experiência de combate visceral que desafia tudo o que você sabe sobre heróis e vilões aguarda sua chegada.",
    "visit_text": "<span class=\"highlight-hero bold\">Visite o estande da Invincible VS e mostre seu valor!</span>",
    "address": "Rua 5, esquina com a Rua F. Para mais informações, consulte o mapa oficial.",
    "question_prompt":"Chegou a hora de rever seus combates e, com sinceridade, fazer sua avaliação",
    "review_title": "Conte suas impressões sobre o INVINCIBLE VS",
    "review_optional": "Quer falar algo sobre <span class=\"highlight-white\">Invincible VS</span>?",

    "rating": {
      "graphics": "GRÁFICOS",
      "gameplay": "JOGABILIDADE",
      "fun": "DIVERSÃO",
      "challenge": "DESAFIO",
      "ambience": "AMBIENTAÇÃO"
    },

    "extra_title": "Mergulhe em um mundo onde artes marciais ancestrais encontram máquinas a vapor em um espetáculo visual de tirar o fôlego",
    "extra_synopsis": "Em <span class=\"highlight-white\"> Phantom Blade Zero </span>, você é um assassino de elite em uma corrida contra o tempo para desmascarar conspirações sombrias e restaurar a honra em um universo 'Kungfupunk' brutal e fascinante.",
    "extra_highlight": "EXPERIMENTE DE FORMA INÉDITA ESTE JOGO NA GAMESCON LATAM AGORA MESMO!",
    "extra_cta": "Visite o estande para dominar a lâmina fantasma!",
    "extra_button": "CONTINUAR",

    "zone_intro_title": "Último portal: A <span class=\"highlight-hero-bigger\">Hero Zone </span> se revela. Uma lenda antiga pede sua ajuda",
    "zone_intro_text": "Para inscrever runas em sua espada lendária, busque a palavra que te trará poder ilimitado. No coração da <span class=\"highlight-hero\">Hero Zone</span> as palavras de poder estão escondidas"
  },

  "herozone": {
    "point_phone_totem":"Aponte o celular para esta imagem",
    "target_title": "Você está se aproximando do fim. Use seu smartphone para localizar a palavra.",
    "target_text": "O local para buscá-la é na Hero Zone.",

    "success_title": "Ao inscrever a palavra na espada, ela volta ao seu formato original",
    "success_text": "Ela se transforma em um dos fragmentos que você busca",

    "failure_title": "Você inscreve a palavra",
    "failure_text": "Mas logo que termina ela desaparece e nada acontece. Tente novamente",

    "option_a_title": "Os mundos colidem e os maiores heróis da Terra precisam de um novo comando",
    "option_a_button": "CONTINUAR",

    "synopsis_placeholder": "Junte-se aos Vingadores e aos Guardiões nesta convergência de poderes extraordinários para deter uma ameaça que atravessa dimensões. A justiça precisa de você para que o equilíbrio da Marvel seja restaurado na gamescom latam.",
    "visit_text": "Experimente de forma inédita este jogo na gamescom latam agora mesmo!",
    "address": "Explore de forma antecipada Marvel Tokon na <span class=\"highlight-hero\">Hero Zone!</span>",

    "zone_intro_title": "Fechando os olhos, você sente a energia dos fragmentos respondendo aos portais instáveis.",
    "zone_intro_text_1": "Manipulando as energias de cada um dos fragmentos <span class=\"highlight-hero\">você abre simultaneamente os quatro portais, que te cercam em puro descontrole.</span>",
    "zone_intro_text_2": "Cada palavra que você aprendeu retorna à sua memória, e ao declará-las em ordem, o caos dá lugar ao equilíbrio.<span class=\"highlight-hero\"> Seu dever como Guardião foi cumprido.</span>"
  },

  "final": {
    "survey_intro": "Os portais estão estáveis novamente e os caminhos para os mundos se tornam seguros. Mas antes de receber sua recompensa, o Conselho dos Mundos quer saber:",
    "survey_title": "Por que você veio até aqui?",

    "rating_title": "Dê uma nota de 1 a 5 para a experiência como um todo.(1 a 5)",

    "question_why_title": "2 - O que te motivou a chegar até o fim?",
    "question_why_option_a": "<span class=\"highlight-white\">A)</span> A história",
    "question_why_option_b": "<span class=\"highlight-white\">B)</span> A premiação",
    "question_why_option_c": "<span class=\"highlight-white\">C)</span> Fazer a atividade com amigos",
    "question_why_option_d": "<span class=\"highlight-white\">D)</span> Curiosidade",

  "question_world_title": "3 - Qual mundo você mais gostou?",
    "question_world_option_a": "<span class=\"highlight-white\">A)</span> <span class=\"highlight-shadow\">Shadow Zone</span>",
    "question_world_option_b": "<span class=\"highlight-white\">B)</span> <span class=\"highlight-neo\">Neo Zone</span>",
    "question_world_option_c": "<span class=\"highlight-white\">C)</span> <span class=\"highlight-hero\">Hero Zone</span>",
    "question_world_option_d": "<span class=\"highlight-white\">D)</span> <span class=\"highlight-open\">Open Zone</span>",

    "review_optional": "Deixe um comentário para o nosso time",

    "survey_continue": "CONTINUAR",
    "survey_modal_text": "Suas respostas serão registradas na Grande Crônica dos Guardiões",

    "success_title": "A gamescom latam está salva!",
    "success_text": "Você, Guardião, restaurou o equilíbrio dos quatro portais. Agora, o Conselho dos Mundos concede a você sua recompensa",

    "success_text_highlight": "Você, Guardião, <span class=\"highlight-hero\"> restaurou o equilíbrio dos quatro portais.</span> Agora, o Conselho dos Mundos concede a você sua recompensa",

    "final_code_label": "AQUI ESTÁ SEU CÓDIGO DE FINALIZAÇÃO",
    "final_code_help": "Dirija-se à área de retirada dos brindes, localizada no Ponto Epix, na Rua B entre as ruas 5 e 6, próximo à área B2B e retire seus espólios. Que sua lenda inspire os demais!",

    "final_error_text": "Erro ao enviar código",
    "final_retry_button": "TENTAR NOVAMENTE"
  }
}